import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=1994e7d7&"
import script from "./Window.vue?vue&type=script&lang=ts&"
export * from "./Window.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports